<template>
          <!-- contents -->
          <div id="contents">
            <div class="contents_wrap">
              <!-- contents_head -->
              <!-- breadcrumbs -->
              <skp-breadcrumbs @page-title="val => pageTitle = val" />
              <!-- //breadcrumbs -->
              <h2 class="pg_title">{{ pageTitle }}</h2>
              <!-- //contents_head -->

              <!-- srchTop_wrap -->
              <div class="srchTop_wrap">
                <article class="srch_basic">
                  <div class="srch_grup">
                    <ul class="w50">
                      <li class="tit_150">Subsidiary</li>
                      <li data-input-type="select" class="w100-150">
                        <fieldset class="ui_fieldset set_3">
                          <div>
                            <select id="selectRhqCd1" name="selectRhqCd1" v-model="selectRhqCd" @change="changeRhqCd($event)" class="slt_white w100">
                                <option value="" v-if="isAllUser() ? true : false" >{{ $t('FIELD.GLOBAL.ALL') }}</option>
                                <option v-for="(item, index) in rhqCdList"
                                        :key="item.code"
                                        :value="item.code"
                                        :selected="selectRhqCd ? (item.code == selectRhqCd ? true : false) : (index === 0 ? true : false)">{{item.codeName}}</option>
                            </select>
                          </div>
                          <div>
                            <select id="selectRhqSubCd1" name="selectRhqSubCd1" v-model="selectRhqSubCd" @change="changeRhqSubCd($event)" class="slt_white w100">
                                <option value="" v-if="isAllUser() ? true : false" >{{ $t('FIELD.GLOBAL.ALL') }}</option>
                                <option v-for="(item, index) in rhqSubCdList"
                                        :key="item.code"
                                        :value="item.code"
                                        :selected="selectRhqSubCd ? (item.code == selectRhqSubCd ? true : false) : (index === 0 ? true : false)">{{item.codeName}}</option>
                            </select>
                          </div>
                        </fieldset>
                      </li>
                    </ul>
                    <ul class="w50">
                      <li class="tit_150">Level</li>
                      <li data-input-type="select" class="w100-150">
                        <select id="levelCd" name="levelCd" v-model="levelCd" class="slt_white w100">
                            <option value='' selected>{{$t('FIELD.GLOBAL.ALL')}}</option>
                            <option value="1">ASC/CS</option>
			                <option value="2">Subsidiary</option>
			                <option value="3">RHQ</option>
                        </select>
                      </li>
                    </ul>
                    <ul class="w50">
                        <li class="tit_150">Inquory</li>
                            <li data-input-type="select" class="w100-150">
                                <fieldset class="ui_fieldset set_2">
                                    <div>
                                        <select class="slt_white w100" v-model="inquiry1Code" @change="inquiryList(2)">
                                            <option value="">{{ $t('FIELD.GLOBAL.ALL') }}</option>
                                            <option
                                                v-for="item in inquiry1CodeList"
                                                :value="item.CD" :key="item.CD"
                                                >{{ item.CD_NAME }}</option
                                            >
                                        </select>
                                    </div>
                                    <div>
                                        <select class="slt_white w100" v-model="inquiry2Code">
                                            <option value="">{{ $t('FIELD.GLOBAL.ALL') }}</option>
                                            <option
                                                v-for="item in inquiry2CodeList"
                                                :value="item.CD" :key="item.CD"
                                                >{{ item.CD_NAME }}</option
                                            >
                                        </select>
                                    </div>
                                </fieldset>
                            </li>
                    </ul>
                    
                    <ul class="w50">
                        <li class="tit_150">
                            Period <em class="txt_mandatory">*</em>
                        </li>
                        <dd data-input-type="date">
                            <fieldset class="ui_fieldset">
                                <span class="date-wrap">
                                    <label>
                                        <input id="fromDate" type="text" class="date_input w100p bg_white" readonly :placeholder="$t('FIELD.KNOWLEDGE.SEARCH.FROMDATE')">
                                        <a href="javascript:" class="in_btn" id="icoFromDate"><i class="ico_date"></i><span class="sr_only">{{ $t('FIELD.GLOBAL.DATE') }}</span></a>
                                    </label>
                                    <div id="from-picker-container" style="margin-top: -1px;"></div>
                                </span>
                                <em class="txt_space"></em>
                                <span class="date-wrap">
                                    <label>
                                        <input id="toDate" type="text" class="date_input w100p bg_white" readonly :placeholder="$t('FIELD.KNOWLEDGE.SEARCH.TODATE')">
                                        <a href="javascript:" class="in_btn" id="icoToDate"><i class="ico_date"></i><span class="sr_only">{{ $t('FIELD.GLOBAL.DATE') }}</span></a>
                                    </label>
                                    <div id="to-picker-container" style="margin-top: -1px;"></div>
                                </span>
                            </fieldset>
                        </dd>
                    </ul>
                    
                    
                  </div>
                  <div class="srch_grupR_bottom">
                    <span class="btn">
                      <a href="javascript:" class="btn_srch" @click="search(1)">Search</a>
                    </span>
                  </div>
                </article>
              </div>
              <!-- Grid -->
              <div class="grid_wrap number-cell">
                    <!-- Count -->
                <!-- <div class="grid_total">
                    Total&nbsp;Count&nbsp;
                    <em>{{ totalCount | numberFormat }}</em>
                </div> -->
                <div class="btn_wrap number-cell">
                    <a
                            href="javascript:"
                            class="btn_white"
                            @click="excelDownload()"
                            title
                        >{{ $t('FIELD.GLOBAL.EXCELDOWNLOAD') }}</a>
                </div>
                <!-- Grid -->
                <toast-grid
                    :gridId="gridId"
                    ref="GridId"
                    :data="gridData"
                    :columns="columns"
                    :options="options"
                    :header="header"
                    :key="gridKey"
                    :pageOptions="pageOptions"
                    :isTotalCount="false"
                    :click="contentClick"
                />
            </div>

            <!-- <div class="paginate">
                <sdl-pagination
                    :current-page="currentPage"
                    :total-rows="totalCount"
                    :per-page="perPage"
                    @change="search"
                    align="center"
                />
             </div> -->
            </div>
          </div>
          <!-- contents -->

</template>

<script>
import Vue                                  from 'vue';
import { mapActions, mapGetters }           from 'vuex';
import _                                    from 'lodash';
import $                                    from 'jquery';
import qs                                   from 'query-string';
import axios                                from 'axios';
import moment                               from 'moment';
import api                                  from '@/service';
import store                                from '@/vuex/store';
import constants                            from '@/constants';
import SDLLocale                            from '@/mixin/SDLLocale';
import { SDLUtil, StringUtil, MenuUtil }    from '@/utils';
import { EventBus }                         from '@/utils/EventBus';


import SKPBreadcrumbs                       from '~vb/main/SKPBreadcrumbs';
import DatePicker                           from '~c/DatePicker';
import ToastGrid                            from '~c/ToastGrid';

import ExcelDownloadPopup                   from '~vb/common/ExcelDownloadPopup';

// java to moment dateformat parser
require('moment-jdateformatparser');

const fetchGridData = params => axios.post(
    `${SDLUtil.API_URL}/basis/admin/statisticsManager/qnAStatusSearch.skp`,
    qs.stringify(params),
    { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }
);

export default {
    name : 'UnreadList',
    props : {

    },
    data() {
        return {
            isProcess: true,

            selectRhqCd: '',
            selectRhqNm: '',
            selectRhqSubCd: '',
            selectRhqSubNm: '',

            rhqCdList: [],
            rhqSubCdList: [],

            levelCd: '',

            inquiry1Code: '',
            inquiry2Code: '',
            inquiry1CodeList: [],
            inquiry2CodeList: [],

            FROM_DATE: {},     
            TO_DATE: {},    

            pageTitle : '',
            perPage: parseInt(localStorage.getItem('listRows') || 10),
            currentPage: 1,
            totalCount : 0,
            gridId : "unreadGrid",
            gridKey: 0,
            gridData : [],
            header: {
                height: 80,
                complexColumns: [
                    {
                        header: 'On-Time Answer',
                        name: 'mergeColumn1',
                        childNames: ['TOTAL', 'D', 'D1', 'D2']
                    },
                    {
                        header: 'On-Time Feedback(%)',
                        name: 'mergeColumn2',
                        childNames: ['ON_TIME_FEEDBACK_D0','ON_TIME_FEEDBACK_D1','ON_TIME_FEEDBACK_D2']
                    },
                ]
            },
            columns : [
                {
                    header: "Subsidiary",
                    name: "SUBSIDIARY_NM_CON",
                    //width: 200,
                    align: "left",
                    sortable: false,
                    resizable: true,
                },
                {
                    header: "Level",
                    name: "DEPT_LEVEL_NM",
                    width: 200,
                    align: "left",
                    sortable: false,
                    resizable: true,
                },
                {
                    header: "Inquiry",
                    name: "INQUIRY_CNT",
                    align: "center",
                    width: 120,
                    sortable: false,
                    resizable: true,
                },
                {
                    header: "Answer",
                    name: "ANSWER_CNT",
                    align: "center",
                    width: 80,
                    sortable: false,
                    resizable: true,
                },
                {
                    header: "Open",
                    name: "PENDING_CNT",
                    width: 80,
                    align: "center",
                    sortable: false,
                    resizable: true,
                },
                {
                    header: "Answer Rate(%)",
                    name: "ANS_RATE",
                    width: 110,
                    align: "center",
                    sortable: false,
                    resizable: true,
                },
                {
                    header: "Total",
                    name: "TOTAL",
                    width: 100,
                    align: "center",
                    sortable: false,
                    resizable: true,
                },
                {
                    header: "D",
                    name: "D",
                    align: "center",
                    width: 80,
                    sortable: false,
                    resizable: true,
                },
                {
                    header: "D+1",
                    name: "D1",
                    align: "center",
                    width: 80,
                    sortable: false,
                    resizable: true,
                },
                {
                    header: "D+2",
                    name: "D2",
                    align: "center",
                    width: 80,
                    sortable: false,
                    resizable: true,
                },
                {
                    header: "D+0",
                    name: "ON_TIME_FEEDBACK_D0",
                    align: "center",
                    width: 80,
                    sortable: false,
                    resizable: true,
                },
                {
                    header: "D+1",
                    name: "ON_TIME_FEEDBACK_D1",
                    align: "center",
                    width: 80,
                    sortable: false,
                    resizable: true,
                },
                {
                    header: "D+2",
                    name: "ON_TIME_FEEDBACK_D2",
                    align: "center",
                    width: 80,
                    sortable: false,
                    resizable: true,
                },
                {
                    header: "Forwarded",
                    name: "FORWARDED_CNT",
                    align: "center",
                    width: 80,
                    sortable: false,
                    resizable: true,
                },
                
            ],
            options : {
                scrollX: true,
                scrollY: false,
                header: { height: 45 },
                rowHeight: 45,
            },
            pageOptions : {},
        }
    },
    computed: {
        ...mapGetters({
            userRoles:  'getRoles',
            userCorpCd: 'getCorpCd',
            params:     'getParams',
            locale:     'getLocale',
            menus:      'getMenus',
            loginNo:    'getLoginNo',
            loginRhq:   'getLoginRhq'
        }),
        getDateformat() {
            return localStorage.getItem('mDateFormat');
        },
        getLoginUser() {
            return SDLUtil.getLoginedUserInfo();
        },
        getLoginRHQCd() {
            return this.loginRhq || '';
        },
        getLoginCompanyCd() {
            return this.userCorpCd || '';
        },
        getLoginNo() {
            return this.loginNo || '';
        },
        getUserRole() {
            return this.userRoles || '';
        },
    },
    components: {
        'skp-breadcrumbs' : SKPBreadcrumbs,
        'toast-grid' : ToastGrid
    },
    methods: {
         async getCodeComboList(categoryVal, categoryCode) { 
            const codeResp = await api.getComboList(categoryVal, categoryCode, this.getUserCorpCd);
            return codeResp;
        },
        async getCodeComboList1(categoryVal, categoryCode) {
            const codeResp = await api.getComboList(categoryVal, categoryCode, this.getLoginNo);
            return codeResp;
        },
        getComboBoxVal(comboId) {
            return document.getElementById(comboId) ? document.getElementById(comboId).value : "";
        },
        getComboBoxName(comboId) {
            return document.getElementById(comboId) ? document.getElementById(comboId).name : "";
        },
        // 지역 코드 변경 이벤트
        changeRhqCd(e) {
            let comboValue = this.getComboBoxVal(e.target.id);
            if(comboValue == "") {
                this.rhqSubCdList = [], this.selectRhqSubCd = '';
            } else {
                this.getCodeComboList1(comboValue, "SUB_AUTH_ACCESS_CD").then(data => {
                    this.rhqSubCdList = data;
                    this.selectRhqSubCd = '';
                });
            }
        },
        // 법인 코드 변경 이벤트
        changeRhqSubCd(e) {
            let comboValue = this.getComboBoxVal(e.target.id);
            if(comboValue == "") {
                this.selectRhqSubCd = '';
                this.selectRhqSubNm = '';
            } else {
                this.selectRhqSubCd = this.getComboBoxVal(e.target.id);
                this.selectRhqSubNm = this.getComboBoxName(e.target.id);
            }
            
        },

        // 권한체크
        isAllUser(){
            
            if(this.getUserRole.includes(`${constants.SYSTEM_ADMIN}`) || 
               this.getUserRole.includes(`${constants.GBM_ADMIN}`) ||
               this.getUserRole.includes(`${constants.RHQ_ADMIN}`)) 
            {
                return true;
            }else{
                return false;
            }
            
        },

        async inquiryList(v) {
            let type = 'inquiryType' + v;
            if (v === 3) {
                type = 'kpi_charge';
            } else if (v === 4) {
                type = 'gbm_cd';
            }
            return await axios
                .post(
                    `${SDLUtil.API_URL}/basis/common/inquiryItem/inquiryItemList.skp`,
                    qs.stringify({
                        type: type,
                        useyn: 'Y',
                        deptLevelCd: this.deptLevelCd,
                        deptNo: this.deptNo,
                        value: this.inquiry1Code,
                    }),
                )
                .then(resp => {
                    if (v === 1) {
                        this.inquiry1Code = '';
                        this.inquiry1CodeList = resp.data.result.rowData;
                        this.inquiryList(2);
                    } else if (v === 2) {
                        this.inquiry2Code = '';
                        this.inquiry2CodeList = resp.data.result.rowData;
                    } else if (v === 3) {
                        this.kpiChargeList = resp.data.result.rowData;
                    } else if (v === 4) {
                        this.gbmCdList = resp.data.result.rowData;
                    }
                });
        },
        

        // 버튼 이벤트
        async search(pageNo) {
            
            let validContents = this.registVerifyContents();
            if(validContents) {
                if (!pageNo) pageNo = 1;
                const mFormat = localStorage.getItem('mDateFormat');
                let params = {
                    page             : pageNo,
                    RHQCD            : this.selectRhqCd,
                    RHQSUBCD         : this.selectRhqSubCd,
                    LEVELCD          : this.levelCd, 
                    INQUIRY1CODE     : this.inquiry1Code,
                    INQUIRY2CODE     : this.inquiry2Code,
                    FROM_DATE        : this.rangePicker.getStartDate() ? moment(this.rangePicker.getStartDate()).format(mFormat) : '',
                    TO_DATE          : this.rangePicker.getEndDate() ? moment(this.rangePicker.getEndDate()).format(mFormat) : ''
                };

                SDLUtil.showLoadingBar(true);
                const response = await fetchGridData(params)
                    .then(res => {
                        let data = res.data;
                        this.gridData = data.result;
                        this.gridKey++;
                        this.currentPage = pageNo;

                        this.$nextTick(() => {
                            let idx = 0;    
                            for(let row of this.gridData){
                                if(row.SUBSIDIARY_NM_CON.indexOf("Total") >= 0 || row.DEPT_LEVEL_NM.indexOf("Total") >= 0) {
                                    this.$refs.GridId.addRowClassName(idx, 'sub_total');
                                }
                                idx++;
                            }
                        });

                        SDLUtil.showLoadingBar(false);
                    })
                    .catch(err => {
                        SDLUtil.errorAlert(err);
                        SDLUtil.showLoadingBar(false);
                    });
            }
        },
        // 컨텐츠 클릭 이벤트 -> KnowledgeListGrid
        contentClick(e, rowData, grid) {
            
        },
        excelDownload() {
            const startDate = moment(this.rangePicker.getStartDate());
            const endDate = moment(this.rangePicker.getEndDate());
            const dateDiff = Math.abs(endDate.diff(startDate, 'days'));
            if (dateDiff > 31) {
                SDLUtil.alert({
                    title: 'Alert',
                    msg: 'Maximum period range for Export to Excel is 1 month',
                });
                return;
            }

            SDLUtil.confirm({
                msg: 'Do you want to download the Excel file?<br>Data will be download up to 5000 lines.',
                onOkEvt: () => {
                    SDLUtil.showLoadingBar(true);
                    const mFormat = localStorage.getItem('mDateFormat');
                    return axios
                        .post(
                            `${SDLUtil.API_URL}/basis/admin/statisticsManager/qnAStatusExcel.skp`,
                            qs.stringify({
                                RHQCD            : this.selectRhqCd,
                                RHQSUBCD         : this.selectRhqSubCd,
                                LEVELCD          : this.levelCd, 
                                INQUIRY1CODE     : this.inquiry1Code,
                                INQUIRY2CODE     : this.inquiry2Code,
                                FROM_DATE        : this.rangePicker.getStartDate() ? moment(this.rangePicker.getStartDate()).format(mFormat) : '',
                                TO_DATE          : this.rangePicker.getEndDate() ? moment(this.rangePicker.getEndDate()).format(mFormat) : ''
                            }),
                        )
                        .then(resp => {
                            SDLUtil.showLoadingBar(false);
                            if (resp.data.EXCEL_FILES.length > 0) {
                                SDLUtil.show(
                                    ExcelDownloadPopup,
                                    {
                                        title: SDLUtil.getMsgProp('TITLE.EXCEL.DOWNLOAD'),
                                        excelFiles: resp.data.excelFiles,
                                    },
                                    {
                                        height: 'auto',
                                    },
                                );
                            }
                            SDLUtil.showLoadingBar(false);
                        })
                        .catch(err => {
                            Vue.$log.error(err);
                            SDLUtil.errorAlert(err);
                            SDLUtil.showLoadingBar(false);
                        });
                },
            });
        },
        registVerifyContents() {
            let validList = [''];
            if(SDLUtil.isNull(this.rangePicker.getStartDate()))    validList.push((validList.length > 0 ? '<br/>' : '') + '<span class="txt_color1">' + 'Period' + '</span>');
            if(SDLUtil.isNull(this.rangePicker.getEndDate()))    validList.push((validList.length > 0 ? '<br/>' : '') + '<span class="txt_color1">' + 'Period' + '</span>');
            if(validList.length > 1) {
                SDLUtil.alert({
                    msg: 'The following fields are required to start search.' + '<br/>' + '<span class="txt_color1">' + 'Period' + '</span>',
                    class: 'sm_size'
                });
                return false;
            } else {
                return true;
            }
        },

    },
    created() {
        
    },

    mounted() {

        this.$nextTick(() => {
            this.getCodeComboList1(this.getLoginNo, "RHQ_AUTH_ACCESS_CD")
                .then(data => {
                    this.rhqCdList = data;
                    this.selectRhqCd =  this.getLoginRHQCd;
                });

            this.getCodeComboList1(this.getLoginRHQCd, "SUB_AUTH_ACCESS_CD")
                .then(data => {
                    this.rhqSubCdList = data;
                    this.selectRhqSubCd = this.getLoginCompanyCd;
                });
            this.inquiryList(1);    
            let toDate = new Date();    
            let fromDate = toDate.setMonth(toDate.getMonth() - 1);
            //this.FROM_DATE = DatePicker.create('from-picker-container', 'fromDate', 'icoFromDate', 'en', {} ,fromDate);
            //this.TO_DATE   = DatePicker.create('to-picker-container', 'toDate', 'icoToDate', 'en', {} ,new Date());    
            this.rangePicker = DatePicker.createRangeWithOpener(
                            'from-picker-container', 'fromDate', 'icoFromDate',
                            'to-picker-container', 'toDate', 'icoToDate',
                            { type: 'date', locale: 'en', showToday: false },
                            (new moment()).add(-1, 'month').toDate(),
                            (new moment()).toDate()
            );
        });
    },

    beforeDestroy() {

    }
};
</script>

<style>
    /*  사용시 해당 컨포넌트에서만 사용 */
.zindex9999 { z-index: 99999999; }
.top20 {top: -20px;}
.float-none {float: none;}
.ftColor { color: dodgerblue!important; font-weight: bold!important; }
.sub_total {
  background: #f9f9f9 !important;
  font-weight: bold;
  width: 100% !important;
  height: 40px !important;
}
.tui-datepicker {
    z-index: 9999;
    border: 1px solid #aaa;
    background-color: white;
    position: absolute;
}
</style>


// WEBPACK FOOTER //
// src/skpComponents/view/admin/statisticsManager/qnAStatusList.vue